<template>
    <div class="consultant-registration-form">
        <slot name="title-desc"></slot>
        <div class="row">
            <SubscriberRegistrationForm>
                <template #password-reset-offer>
                    <slot name="password-reset-offer"></slot>
                </template>
                <template #sign-in-offer>
                    <slot name="sign-in-offer"></slot>
                </template>
                <template #tnc-label>
                    <slot name="tnc-label"></slot>
                </template>
            </SubscriberRegistrationForm>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { SubscriberRegistrationForm } from '@/modules/proportal/components';
</script>